var angular = require("angular");
var app_deps = [
  require("amt_admin"),
  require("./by_country"),
  require("./by_env"),
  require("./by_days_since_install"),
  require("./by_product_key"),
];
var app = angular.module("ww2_analytics.purchases", app_deps.map(x => x.default));
var { provider_states_by_gameplay } = require('amt_admin/utils.js');

app.service("purchases_api", [
  "jsonrpc",
  function(jsonrpc) {
    var service = jsonrpc.newService("purchases");
    this.last_purchases = service.createMethod("last_purchases");
    this.average_count_by_days = service.createMethod("average_purchases_count_by_days");
    this.average_sum_by_number = service.createMethod("average_purchases_sum_by_number");
  }
]);

var by_country_tpl = require("./by_country/main.html");
var by_env_tpl = require("./by_env/main.html");
var by_days_since_install_tpl = require("./by_days_since_install/main.html");
var by_product_key_tpl = require("./by_product_key/main.html");
var by_product_key_free_tpl = require("./by_product_key_free/main.html");
var errors_tpl = require("./errors/main.html");
var last_purchases_tpl = require("./last_purchases/main.html");
var average_purchases_count_by_days_tpl = require("./average_purchases_count_by_days.html");
var average_purchases_sum_by_number_tpl = require("./average_purchases_sum_by_number.html");
const contract_subscription_tpl = require('./contract_subscriptions/main.html');

app.config([
  "$stateProvider",
  function($stateProvider) {
    provider_states_by_gameplay($stateProvider, {
        adult_idler: [
          'amt.ww2.purchases.by_env',
        ],
      })
      .state("amt.ww2.purchases", {
        url: "/purchases",
        abstract: true,
//        template:
//          "<div class='row'><div class='col-md-12' ui-view></div></div>",
        views: {
            "main-filter": {
                template: "" +
                "<div class='row'><div class='col-lg-12'>" +
                "   <amt-form-inline" +
                "      name='purchases.PurchaseSegmentsForm'" +
                "      on-submit='updateCharts(model)'" +
                "      extend-model='$root.chartParams.filters'" +
                "   ></amt-form-inline>" +
                "</div></div>" +
                ""
            },
            "": { template: "<div class='row'><div class='col-md-12' ui-view></div></div>"}
        },
        data: {
          priority: 800,
          title: "Purchases",
          role: "purchases"
        },
        menu: {
          fa: "usd",
          childs: [
            {
              state: "amt.ww2.purchases.by_country",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.by_env",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.by_days_since_install",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.by_product_key",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.by_product_key_free",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.errors",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.last_purchases",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.average_purchases_count_by_days",
              fa: "usd"
            },
            {
              state: "amt.ww2.purchases.average_purchases_sum_by_number",
              fa: "usd"
            },
            {
              state: 'amt.ww2.purchases.contract_subscriptions',
              fa: 'usd',
            },
            {
              state: 'amt.ww2.purchases.video_revenue',
              fa: 'usd',
            },
          ]
        }
      })
      .state("amt.ww2.purchases.by_country", {
        url: "/by_country",
        template: by_country_tpl,
        reloadOnSearch: false,
        data: {
          priority: 803,
          title: "by Country",
          role: "purchases"
        }
      })
      .state("amt.ww2.purchases.by_env", {
        url: "/by_env",
        template: by_env_tpl,
        reloadOnSearch: false,
        data: {
          priority: 802,
          title: "by Env",
          role: "purchases"
        }
      })
      .state("amt.ww2.purchases.by_days_since_install", {
        url: "/by_days_since_install",
        template: by_days_since_install_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: "by Days since Install",
          role: "purchases"
        }
      })
      .state("amt.ww2.purchases.by_product_key", {
        url: "/by_product_key",
        template: by_product_key_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: "by Product Key",
          role: "purchases"
        }
      })
      .state("amt.ww2.purchases.by_product_key_free", {
        url: "/by_product_key_free",
        template: by_product_key_free_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: "by Product Key Free",
          role: "purchases",
        },
      })
      .state("amt.ww2.purchases.errors", {
        url: "/errors",
        template: errors_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: "Errors",
          role: "purchases"
        }
      })
      .state("amt.ww2.purchases.average_purchases_count_by_days", {
          url: "/average_count_by_days",
          template: average_purchases_count_by_days_tpl,
          reloadOnSearch: false,
          data: {
            priority: 801,
            title: "Average count by days",
            role: "purchases"
          },
          controller: ["$scope",
              "$location",
              "purchases_api",
              "chartFilters",
              function($scope, $location, purchases_api, chartFilters) {
                $scope.data = {};
                $scope.ranges = {};
                $scope.gradient_colors = [
                  "#ecf8ff",
                  "#E6F5FF",
                  "#DBF0FF",
                  "#D1ECFF",
                  "#C7E8FF",
                  "#BDE4FF",
                  "#B3E0FF",
                  "#A8DCFF",
                  "#9ED8FF",
                  "#94D4FF",
                  "#8AD0FF",
                  "#80CCFF",
                  "#78c4ff"
                ];
                $scope.update_table = function(model) {
                  purchases_api.average_count_by_days(model).then(function(resp) {
                    $scope.data = resp;
                    $scope.calculate_ranges();
                  });
                };
                $scope.calculate_ranges = function() {
                  var data_keys = Object.keys($scope.data[0]);
                  for (var key_i = 0; key_i < data_keys.length; key_i++) {
                    var values_list = [];
                    for (var i = 0; i < $scope.data.length; i++) {
                      values_list.push($scope.data[i][data_keys[key_i]]);
                    }
                    $scope.ranges[data_keys[key_i]] = {
                      min: Math.min.apply(Math, values_list),
                      max: Math.max.apply(Math, values_list)
                    };
                  }
                };
                $scope.apply_color = function(value, key) {
                  if (value != -1) {
                    var position =
                      (value - $scope.ranges[key]["min"]) /
                      ($scope.ranges[key]["max"] - $scope.ranges[key]["min"]);
                    return $scope.gradient_colors[
                      Math.floor(position * ($scope.gradient_colors.length - 1))
                    ];
                  }
                };
                $scope.apply = function(value) {
                  if (value == -1) {
                    return "-";
                  } else if (value == null) {
                    return 0;
                  }
                  else {
                    return value;
                  }
                };
                chartFilters.onChangeChartParams(
                  "update_table",
                  $scope.update_table
                );
                $scope.update_table(chartFilters.get_chart_filters());
              }]
      })
      .state("amt.ww2.purchases.average_purchases_sum_by_number", {
          url: "/average_sum_by_number",
          template: average_purchases_sum_by_number_tpl,
          reloadOnSearch: false,
          data: {
            priority: 801,
            title: "Average sum by number",
            role: "purchases"
          },
          controller: ["$scope",
              "$location",
              "purchases_api",
              "chartFilters",
              function($scope, $location, purchases_api, chartFilters) {
                $scope.data = {};
                $scope.ranges = {};
                $scope.gradient_colors = [
                  "#ecf8ff",
                  "#E6F5FF",
                  "#DBF0FF",
                  "#D1ECFF",
                  "#C7E8FF",
                  "#BDE4FF",
                  "#B3E0FF",
                  "#A8DCFF",
                  "#9ED8FF",
                  "#94D4FF",
                  "#8AD0FF",
                  "#80CCFF",
                  "#78c4ff"
                ];
                $scope.update_table = function(model) {
                  purchases_api.average_sum_by_number(model).then(function(resp) {
                    $scope.data = resp;
                    $scope.calculate_ranges();
                  });
                };
                $scope.calculate_ranges = function() {
                  var data_keys = Object.keys($scope.data[0]);
                  for (var key_i = 0; key_i < data_keys.length; key_i++) {
                    var values_list = [];
                    for (var i = 0; i < $scope.data.length; i++) {
                      values_list.push($scope.data[i][data_keys[key_i]]);
                    }
                    $scope.ranges[data_keys[key_i]] = {
                      min: Math.min.apply(Math, values_list),
                      max: Math.max.apply(Math, values_list)
                    };
                  }
                };
                $scope.apply_color = function(value, key) {
                  if (value != -1) {
                    var position =
                      (value - $scope.ranges[key]["min"]) /
                      ($scope.ranges[key]["max"] - $scope.ranges[key]["min"]);
                    return $scope.gradient_colors[
                      Math.floor(position * ($scope.gradient_colors.length - 1))
                    ];
                  }
                };
                $scope.apply = function(value) {
                  if (value == -1) {
                    return "-";
                  } else if (value == null) {
                    return 0;
                  }
                  else {
                    return value;
                  }
                };
                chartFilters.onChangeChartParams(
                  "update_table",
                  $scope.update_table
                );
                $scope.update_table(chartFilters.get_chart_filters());
              }]
      })
      .state("amt.ww2.purchases.last_purchases", {
        url: "/last_purchases",
        template: last_purchases_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: "Last purchases",
          role: "purchases"
        },
        controller: [
          "$scope",
          "purchases_api",
          "chartFilters",
          function($scope, purchases_api, chartFilters) {
            $scope.data = {};
            $scope.update_purchases_table = function(model) {
              purchases_api.last_purchases(model).then(function(resp) {
                $scope.data = resp;
              });
            };
            chartFilters.onChangeChartParams(
              "update_purchases_table",
              $scope.update_purchases_table
            );
            $scope.update_purchases_table(chartFilters.get_chart_filters());
          }
        ]
      })
      .state('amt.ww2.purchases.contract_subscriptions', {
        url: '/contract_subscriptions',
        template: contract_subscription_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: 'Contract Subscriptions',
          role: 'purchases'
        },
      })
      .state('amt.ww2.purchases.video_revenue', require('./video_revenue').default);
  }
]);

export default app.name;
